import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";

import { useForgotPassword } from "../api/auth";
import { AuthShell } from "../components/AuthShell";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const forgot = useForgotPassword();

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      await forgot.mutateAsync({ email });
    } finally {
      // Always show "done" — server returns 202 even for unknown emails
      // (no enumeration). UX matches.
      setDone(true);
    }
  };

  if (done) {
    return (
      <AuthShell
        title="Vérifiez votre boîte mail"
        subtitle={`Si ${email} est associé à un compte, vous recevrez un lien de réinitialisation dans quelques minutes.`}
        footer={<Link to="/login" className="hover:text-ink dark:hover:text-ink-dark underline">Retour à la connexion</Link>}
      >
        <div className="text-sm text-muted dark:text-muted-dark">
          Le lien est valable 1 heure. Pensez à vérifier vos spams.
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      title="Mot de passe oublié"
      subtitle="Entrez l'email de votre compte. Nous vous enverrons un lien pour le réinitialiser."
      footer={<Link to="/login" className="hover:text-ink dark:hover:text-ink-dark underline">Retour à la connexion</Link>}
    >
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="text-xs text-muted dark:text-muted-dark block mb-1" htmlFor="email">
            Email
          </label>
          <input
            id="email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="bun-textbox w-full px-3 py-2 text-sm rounded-lg border border-black/10 dark:border-white/10 focus:outline-none focus:ring-2 focus:ring-ink/30 dark:focus:ring-white/30"
          />
        </div>
        <button
          type="submit"
          disabled={forgot.isPending}
          className="w-full px-4 py-2 rounded-full bg-ink text-white text-sm font-semibold flex items-center justify-center gap-2 hover:bg-ink/90 disabled:opacity-50"
        >
          {forgot.isPending && <Loader2 className="h-4 w-4 animate-spin" />}
          Envoyer le lien
        </button>
      </form>
    </AuthShell>
  );
}
